import React, {useEffect, useState} from 'react'
import io from 'socket.io-client'
import { SOCKET_URL } from '../utils/api'
import {useAuth} from '../lib/auth'

export const SocketContext = React.createContext();

export const SocketIOProvider = ({children}) => {
    let auth = useAuth()
    const [socket, setSocket] = useState(null)

    //Connect to socket if user is authenticated
    useEffect(() => {
        console.log('[Socket] Socket triggered 1', {socket})
        // Check if user is dashboard
        const isDashboardUser = auth.isAuthenticated &&
                                auth.user === "dashboard"
        // Check if socket is initialized
        const isSocketInitialized = socket !== null
        const isSocketConnected = (isSocketInitialized)?socket.connected: false
        if (isSocketInitialized)
            console.log('[Socket] Socket triggered 2', socket.connected)
        // Only connect socket when user is dashboard
        if(isDashboardUser && (!isSocketInitialized)){
            let _socket = io(SOCKET_URL, {
                path: '/rdcc/scs/',
                transports: ["polling"],
                auth: {
                    client_id: "8OS/nwnsSA==",
                    client_secret: "AstnzhmNUBARWzimIPcQ0M4KICQgCOLC0K7ztrrcbXpTSoZ4dwBu/9mfJQNo3WQ+MFZIRwNnht34byeKaV7XWYg+5X/T+cUxKlWJWq88q228s1zmjKC4RzcYFDO8ZZXxN9rQk4I9w0AOXLkxBv4h0TQ="
                },
                autoConnect: false  // Disable Auto connect to socket for authenticated user only
            })
            _socket.on("connect_error", (err) => {
                console.log('[Socket] Cannot connect socket', err)
            });
            _socket.on("connect", () => {
                console.log('[Socket] Connect socket success')
                console.log('[Socket] Socket triggered 3', _socket.connected)
                setSocket(_socket)
            });
            _socket.on("disconnect", () => {
                console.log('[Socket] Disconnect socket success')
                setSocket(null)
            });
            _socket.connect()
            setSocket(_socket)
        }

    },[auth, socket])

    

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    )
}